import cn from 'classnames/bind';
import { Dropdown, ArrowUp } from 'ui';
import NavigationItemLink from 'ui/layouts/MainNavigation/NavigationItemLink';

import s from './MainNavigation.module.css';

const cx = cn.bind(s);

const NavigationItemWithDropdown = ({
  children, dropdown, href, childLinks,
}) => (
  <Dropdown align="center">
    <Dropdown.Header>
      {({ isOpen }) => (
        <NavigationItemLink href={href} childLinks={childLinks} append={<span className={cx('navItemLinkIcon')}>
          <ArrowUp isOpen={isOpen} />
        </span>}>
          {children}
        </NavigationItemLink>
      )}
    </Dropdown.Header>
    <Dropdown.Content>{dropdown}</Dropdown.Content>
  </Dropdown>
);

export default NavigationItemWithDropdown;
